import React from 'react';
import {MasterLayout} from 'layout';
import {AddHandleLetterOld} from "modules/handle-letters-old";
export default class AddHandleLettersOldPage extends React.Component {

  render() {
    return (
      <MasterLayout routerName={this.props.route.name}>
          <AddHandleLetterOld params={this.props.params}/>
      </MasterLayout>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/handle-letters-old/AddHandleLettersOldPage.jsx